import React from 'react';

const Gemini3Launch = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Google's Gemini 3 family, unveiled at Google I/O 2025, marks the point where Google
      started pulling ahead again in the model race. The flagship Gemini 3 Ultra handles
      multimodal reasoning across text, images, video, and audio in a single model.
      The mid-tier Gemini 3 Flash delivers near-frontier performance at a fraction of the
      cost. And the experimental 1-million-token context window makes it the most
      context-capable commercially available model to date.
    </p>

    <h2>What's new in Gemini 3</h2>
    <p>
      The jump from Gemini 2 to 3 is larger than the previous generation transitions:
    </p>
    <ul>
      <li><strong>Longer context:</strong> Up to 1 million tokens natively - equivalent to about 750,000 words or a large codebase</li>
      <li><strong>Better multimodal understanding:</strong> Gemini 3 can reason across interleaved text, images, charts, and video frames in a single prompt</li>
      <li><strong>Native tool use:</strong> Built-in integration with Google Search, code execution, and structured output</li>
      <li><strong>Improved reasoning:</strong> Gemini 3 Ultra's benchmark scores on MATH, MMLU, and HumanEval all improved substantially over 2 Ultra</li>
    </ul>

    <h2>The Nano Banana connection</h2>
    <p>
      "Nano Banana" was an internal Google codename that appeared in leaked documents and
      API strings in early 2025 - eventually confirmed to refer to Gemini 3.1 Flash Nano,
      an extremely efficient small model designed to run on-device. It powers features like
      on-device summarisation in Android, real-time translation, and smart reply suggestions
      that work without an internet connection.
    </p>
    <p>
      The Nano variants are designed for phones, tablets, and edge devices with limited
      compute. They're not trying to compete with full cloud models - they're trying to
      bring useful AI to every Android device even on a slow connection or offline.
    </p>

    <h2>The 2M token context research</h2>
    <p>
      Alongside Gemini 3, Google's research team published work on extending context to
      2 million tokens experimentally - enough to fit essentially any typical enterprise
      document set in a single prompt. The research explored two key problems: how to
      keep attention quality high over very long contexts, and how to make retrieval
      efficient enough to be practical.
    </p>

    <h2>Google's position after Gemini 3</h2>
    <p>
      Gemini 3 arrived at a time when Google needed a clear win. Gemini 1.0 had launched
      to mixed reviews in late 2023 - technically impressive but awkward in practice.
      Gemini 3 got better feedback: faster, more accurate, more coherent across long
      documents. The integration into Google Workspace (Docs, Sheets, Gmail) also
      accelerated, putting AI directly in the tools hundreds of millions of people use daily.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Google's advantage isn't just model capability - it's integration. Gemini 3 matters
        not just because of benchmark scores, but because it's embedded in Search, Android,
        Chrome, and Workspace. The model race is important, but distribution might be the
        real competition. And there, Google has a head start no one else can easily replicate.
      </p>
    </div>
  </article>
);

export default Gemini3Launch;
